export default {
  'PUSH.COMMON.LANG.AFTER': '(默认)',
  'PUSH.COMMON.CONFIRM.INPUT': '确认输入',
  'PUSH.COMMON.CONFIRM': 'CONFIRM',
  'PUSH.COMMON.APPROVE': 'APPROVE',
  'PUSH.COMMON.REJECT': 'REJECT',
  // 推送实验
  'PUSH.EXPERIMENT.TITLE': '推送实验',
  'PUSH.EXPERIMENT.ARCHIVED': '显示归档实验',
  'PUSH.EXPERIMENT.CREATE': '新建实验',
  'PUSH.EXPERIMENT.CREATE_FAILED': '存在进行中或待审批实验，无法新建。',
  'PUSH.EXPERIMENT.ID': '实验id',
  'PUSH.EXPERIMENT.NAME': '实验名称',
  'PUSH.EXPERIMENT.STATUS': '推送次数',
  'PUSH.EXPERIMENT.USER_COUNT': '实验人数',
  'PUSH.EXPERIMENT.PUSHED_USER_COUNT': '已推次数',
  'PUSH.EXPERIMENT.STATUS_LABEL': '实验状态',
  'PUSH.EXPERIMENT.EXP_PUSH_START_TIME': '实验推送开始时间',
  'PUSH.EXPERIMENT.APPLICANT': '申请人',
  'PUSH.EXPERIMENT.APPROVER': '审批人',
  'PUSH.EXPERIMENT.ACTIONS': '动作',
  'PUSH.EXPERIMENT.STOPPED_STATUS': '已停止',
  'PUSH.EXPERIMENT.COMPLETED_STATUS': '完成',
  'PUSH.EXPERIMENT.TIMEOUT_STATUS': '超时未审批',
  'PUSH.EXPERIMENT.WAITING_STATUS': '待推送',
  'PUSH.EXPERIMENT.PUSHING_STATUS': '推送中',
  'PUSH.EXPERIMENT.REJECTED_STATUS': '审批驳回',
  'PUSH.EXPERIMENT.SEGMENT_TIMEOUT_STATUS': '跑表超时中止',
  'PUSH.EXPERIMENT.DRAFT_STATUS': '草稿',
  'PUSH.EXPERIMENT.CONFIG_DETAIL': '配置详情',
  'PUSH.EXPERIMENT.EDIT': '编辑',
  'PUSH.EXPERIMENT.CREATE.HEADER_EDIT': '编辑推送实验',
  'PUSH.EXPERIMENT.CREATE.HEADER_VIEW': '实验配置详情',
  'PUSH.EXPERIMENT.CREATE.CONFIG_LOADING': '正在加载实验配置…',
  'PUSH.EXPERIMENT.CREATE.CONFIG_LOAD_FAILED':
    '实验配置加载失败，请稍后重试或返回列表',
  'PUSH.EXPERIMENT.CREATE.BACK_TO_LIST': '返回实验列表',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMPTY_HINT': '该配置暂无内容',
  'PUSH.EXPERIMENT.STOP': '结束实验',
  'PUSH.EXPERIMENT.STOP_CONFIRMATION':
    '确认结束该推送实验吗？结束后将无法恢复。',
  'PUSH.EXPERIMENT.CONFIG': '配置信息',
  'PUSH.EXPERIMENT.DOWNLOAD.CONFIG': '下载配置文件',
  'PUSH.CREATE': '新建实验',
  'PUSH.BASE_INFO': '基础信息',
  'PUSH.BUSINESS_SELECT': '业务选择',
  'PUSH.USER_COUNT.TITLE': '可推送玩家数量：',
  'PUSH.USER_COUNT.DESCRIPTION':
    '（当前为预估数量，实际数量在审批通过时会重新拉取）',
  'PUSH.FILE_CHECK_PASS': '文件校验通过',
  'PUSH.CONFIG_PREVIEW': '配置预览',
  'PUSH.EXP_PUSH_START_TIME': '实验开始时间',
  'PUSH.EXP_PUSH_END_TIME': '实验结束时间',
  'PUSH.GROUP_NAME': '分组',
  'PUSH.TITLE_NAME': '标题 (title)',
  'PUSH.BODY_NAME': '内容 (body)',
  'PUSH.PUSH_ID': '推送ID (push_id)',
  'PUSH.SENDING_TIME': '推送时间 (sending_time)',
  'PUSH.TTL_NAME': 'firebase云端保留时间 (ttl)',
  'PUSH.SUBMIT_APPLICATION': '提交发布申请',
  'PUSH.SUBMIT_APPLICATION_TIP':
    '配置审批通过后，将立即暂停所有当前默认推送，并对全量用户按照以上更新的推送计划执行。需谨慎操作',
  'PUSH.EXPERIMENT.CONFIG_CHECK_FAIL': '校验实验配置失败',
  'PUSH.EXPERIMENT.OTHER_ERROR': '其他错误',

  // 默认推送
  'PUSH.DEFAULT.TITLE': '默认推送',
  'PUSH.DEFAULT.ACTIVE_CONFIG': '推送信息',
  'PUSH.DEFAULT.APPROVAL_CONFIG_PREVIEW': '审批详情',
  'PUSH.DEFAULT.HANDLE.CONFIG': '更改默认推送配置',
  'PUSH.DEFAULT.HANDLE.APPROVAL': '默认推送申请中',
  'PUSH.DEFAULT.ACTIVE_STATUS': '生效中',
  'PUSH.DEFAULT.PAUSE_STATUS': '已停止',
  // 默认推送：更改默认推送配置弹窗
  'PUSH.DEFAULT.EDIT.CONFIG.TITLE': '更改默认推送配置',
  'PUSH.DEFAULT.HANDLE.INIT_STRATEGY': '初始化策略',
  'PUSH.DEFAULT.HANDLE.CONFIG_TIPS':
    '配置发布后，应用到线上全部玩家，需谨慎操作',
  'PUSH.DEFAULT.HANDLE.CONFIG_LABEL': '选择配置',
  'PUSH.DEFAULT.HANDLE.SELECT_CONFIG': '请选择配置',
  'PUSH.DEFAULT.HANDLE.SEARCH': '搜索',
  'PUSH.DEFAULT.HANDLE.SELECT_CONFIG.PREVIEW': '预览配置',
  'PUSH.DEFAULT.HANDLE.PUSH_ID': '推送ID (push_id)',
  // 默认推送：暂停、重启默认推送
  'PUSH.DEFAULT.HANDLE.PAUSE_PUSH': '暂停默认推送',
  'PUSH.DEFAULT.HANDLE.RESTART_PUSH': '重启默认推送',
  'PUSH.DEFAULT.MODAL.PAUSE_PUSH': '暂停默认推送',
  'PUSH.DEFAULT.MODAL.RESTART_PUSH': '重启默认推送',
  'PUSH.DEFAULT.STOP.TIPS.1':
    '确认后，对于<b class="color-333">全量用户</b>，将从<b class="color-333">下个推送时间节点开始停止默认推送</b>。需谨慎操作。',
  'PUSH.DEFAULT.STOP.TIPS.2':
    '确认后，对于<b class="color-333">全量用户</b>，将从<b class="color-333">下个推送时间节点开始恢复默认推送</b>。需谨慎操作。',
  'PUSH.DEFAULT.NO_OPERABLE_CONFIG': '当前无可操作的默认推送配置',
  // 默认推送：变更记录
  'PUSH.DEFAULT.DESCRIPTION': '变更记录',
  'PUSH.DEFAULT.CONFIRM': '默认推送变更记录',
  'PUSH.DEFAULT.ACTION_TIME': '操作时间',
  'PUSH.DEFAULT.ACTION_TYPE': '操作类型',
  'PUSH.DEFAULT.ACTION_CONTENT': '操作内容',
  'PUSH.DEFAULT.ACTION_USER': '操作人',
  'PUSH.DEFAULT.PUSH_STATUS': '推送启停',
  'PUSH.DEFAULT.CONFIG_APPROVAL': '配置审批',
  'PUSH.DEFAULT.PAUSE_PUSH': '暂停推送',
  'PUSH.DEFAULT.RESTART_PUSH': '重启推送',
  'PUSH.DEFAULT.APPROVED_DESCRIPTION': '审批通过: ',
  'PUSH.DEFAULT.REJECTED_DESCRIPTION': '审批驳回: ',
  'PUSH.DEFAULT.CONFIG.UPDATED': '配置更新为',
  'PUSH.DEFAULT.CONFIG_OPERATION': '配置流程操作',
  'PUSH.DEFALUE.CONFIG_UPDAYED': '配置变更申请',
  'PUSH.DEFAULT.DOWNLOAD_CONFIG_FAIL': '下载配置信息失败：数据为空',
  'PUSH.DEFAULT.DOWNLOAD': '下载配置 {name}',
  // 默认推送：列表
  'PUSH.DEFAULT.PUSH_STATUS_NAME': '推送名称',
  'PUSH.DEFAULT.PUSH_STATUS_LABEL': '推送状态',
  'PUSH.DEFAULT.PUSH_INFO_LABEL': '推送信息',
  'PUSH.DEFAULT.APPROVAL_DETAIL_LABEL': '审批详情',
  'PUSH.DEFAULT.PUSH_TIME_LABEL': '推送时间（用户当地时区）',
  'PUSH.DEFAULT.PUSH_ID': '推送ID (push_id)',
  // 默认推送：审批列表
  'PUSH.DEFAULT.APPLIED_BY': '申请人: ',
  'PUSH.DEFAULT.SUBMITTED_AT': '申请时间: ',
  'PUSH.DEFAULT.WIHTDRAW_SUB': '撤回申请',
  'PUSH.DEFAULT.WIHTDRAW_CONFIRM':
    '确认撤回当前默认推送变更申请吗？撤回后将回到无申请状态。',
  'PUSH.DEFAULT.WIHTDRAW_SUCCESS': '撤回申请成功',

  // 待审批
  // 待审批：列表
  'PUSH.APPROVAL.TITLE.NAME': '待审批',
  'PUSH.APPROVAL.DESCRIPTION':
    '<b class="color-333">审批规则：</b>同个项目内任一非申请人的 <b class="color-333">member</b> 成员均可审批，申请人本人不可审批。',
  'PUSH.APPROVAL.TYPE': '类型',
  'PUSH.APPROVAL.EXPERIMENT_TYPE': '推送实验',
  'PUSH.APPROVAL.NAME': '名称',
  'PUSH.APPROVAL.CREATED_BY': '创建人',
  'PUSH.APPROVAL.APPLIED_TIME': '提交时间',
  'PUSH.APPROVAL.APPROVE': '去审批',
  'PUSH.APPROVAL.APPLIER_CANNOT_APPROVE': '申请人本人不可审批',
  // 待审批：去审批弹窗
  'PUSH.APPROVAL.RULE': '审批规则',
  'PUSH.APPROVAL.WAIT_TIME':
    '进入页面后需等待 <b style="color: #1F99DE">{num}s</b> 才可执行审批通过。等待期间请完整复核本次配置内容。',
  'PUSH.APPROVAL.APPLICATION_INFO': '申请信息',
  'PUSH.APPROVAL.APPLICATION_TYPE': '类型',
  'PUSH.APPROVAL.EXPERIMENT_NAME': '实验名称',
  'PUSH.APPROVAL.EXP_PUSH_START_TIME': '开始时间',
  'PUSH.APPROVAL.EXP_PUSH_END_TIME': '结束时间',
  'PUSH.APPROVAL.USER_COUNT': '可推送玩家数量',
  'PUSH.APPROVAL.APPLICANT': '申请人',
  'PUSH.APPROVAL.APPLICATION_TIME': '申请时间',
  'PUSH.APPROVAL.CONFIG_DETAIL': '配置详情',
  'PUSH.APPROVAL.DAY': '第N天',
  'PUSH.APPROVAL.PUSH_TIME': '推送时间',
  'PUSH.APPROVAL.PUSH_ID': '推送ID (push_id)',
  'PUSH.APPROVAL.TITLE': '标题',
  'PUSH.APPROVAL.BODY': '内容',
  'PUSH.APPROVAL.TTL_NAME': 'firebase云端保留时间',
  'PUSH.APPROVAL.APPROVED': '审批通过',
  'PUSH.APPROVAL.REJECTED': '审批驳回',
  'PUSH.APPROVAL.WAITING': '需等待{num}秒后审批',
  // 待审批：审批通过 & 审批驳回弹窗
  'PUSH.APPROVAL.APPROVED_DESCRIPTION': '审批通过',
  'PUSH.APPROVAL.APPROVED_CONFIRMATION':
    '确认审批通过当前申请后，系统将立即执行对应发布流程。',
  'PUSH.APPROVAL.APPROVE.DESCRIPTION': '输入 <b>APPROVE</b> 以确认',
  'PUSH.APPROVAL.APPROVE.PLACEHOLDER':
    '仅当完整输入<b>APPROVE</b>后才可继续提交',
  'PUSH.APPROVAL.REJECTED.DESCRIPTION': '输入 <b>REJECT</b> 以确认',
  'PUSH.APPROVAL.REJECTED.PLACEHOLDER':
    '仅当完整输入<b>REJECT</b>后才可继续提交',
  // 待审批：审批驳回弹窗
  'PUSH.APPROVAL.REJECTED_DESCRIPTION': '审批驳回',
  'PUSH.APPROVAL.REJECTED_CONFIRMATION':
    '确认审批驳回当前申请后，系统将结束本次审批流程。',
  'PUSH.APPROVAL.CONFIG_REJECTED_DESCRIPTION': '该配置已被审批驳回',
  'PUSH.APPROVAL.APPROVED_SUCCESS': '审批通过成功',
  'PUSH.APPROVAL.REJECTED_SUCCESS': '审批驳回成功',
  'PUSH.APPROVAL.ALREADY_APPROVED':
    '申请已经被<b class="color-333">{accountName}</b>在<b class="color-333">{approvedTime}</b>审批',
  'PUSH.APPROVAL.APPLICATION_EXPIRED':
    '申请已失效，请联系创建者<b class="color-333">{appliedBy}</b>重新创建',
  // 待审批：审批详情弹窗
  'PUSH.APPROVAL.REJECTED_DETAIL': '审批详情',
  'PUSH.APPROVAL.SUBMIT_FAILED_DESCRIPTION': '提交失败',

  // 创建实验：提交发布申请弹窗
  'PUSH.APPROVAL.SUBMIT_APPLICATION_DESCRIPTION':
    '审批通过后，立即对<b>全量存量可推送玩家</b>执行实验分流，<b>分流期内暂停默认推送</b>；',
  'PUSH.APPROVAL.DIVISION_COMPLETED': '分流完成后：',
  'PUSH.APPROVAL.STRATEGY_DESCRIPTION':
    '1.命中实验的玩家 - 按照实验策略开始推送；',
  'PUSH.APPROVAL.NOT_HIT_EXPERIMENT_PLAYER':
    '2.未命中玩家及新增玩家 - 继续执行默认推送计划。',
  'PUSH.APPROVAL.USER_COUNT_DESCRIPTION':
    '可推送玩家数量为当前预估值，审批通过时系统会重新拉取实际数量。',
  'PUSH.APPROVAL.CONFIRM': 'CONFIRM',
  'PUSH.APPROVAL.SUBMIT_APPLICATION_SUCCESS': '提交发布申请成功',
  'PUSH.EXPERIMENT.APPROVAL.CONFIRM.DESCRIPTION': '请输入<b>CONFIRM</b>',
  'PUSH.EXPERIMENT.APPROVAL.CONFIRM.PLACEHOLDER':
    '仅当完整输入<b>CONFIRM</b>后才可继续提交',

  // 实验
  // 'PUSH.EXPERIMENT.DOWNLOAD_CONFIG_FAILED': '下载配置信息失败：数据为空',
  // 'PUSH.EXPERIMENT.CONFIG_ERROR_FAILED': '配置文件存在错误，请修改后重新上传',
  // 'PUSH.EXPERIMENT.CONFIG_UPLOAD_FAILED': '请先上传配置文件',
  'PUSH.EXPERIMENT.BUSINESS_SELECT_FAILED': '请先选择业务',
  'PUSH.EXPERIMENT.BUSINESS_SELECT_THEN_UPLOAD': '请先选择业务后再上传配置文件',

  'PUSH.EXPERIMENT.ERROR.FILE_CONTENT_INVALID': '文件内容校验出错',
  'PUSH.EXPERIMENT.IMPORT.CSV.ERR.SIZE': '上传文件过大，仅支持1M以内的文件上传',
  'PUSH.EXPERIMENT.ERROR.FILE_INVALID': '文件格式不正确，请核对后重新上传',
  'PUSH.EXPERIMENT.ERROR.NAME_DUPLICATE':
    '该实验名称已存在，请重新编辑后再上传',
  'PUSH.EXPERIMENT.ERROR.CONFIG_RUNNING': '该实验配置正在运行中，无法重复提交',
  'PUSH.EXPERIMENT.ERROR.PAYLOAD_EXCEEDED': '标题与正文总和超过 2048 字符',
  'PUSH.EXPERIMENT.ERROR.DATA_EXCEEDED': '总载荷超过 4096 字节，请精简数据',
  'PUSH.EXPERIMENT.ERROR.INVALID_TIMEFRAME':
    '时间窗口超限：可能会错过首条推送的开始时间，请更改设置后重新申请发布',
  'PUSH.EXPERIMENT.ERROR.MISSING_DEFAULT_LANG':
    '未配置默认语言，请在 JSON 中指定 default_lang',
  'PUSH.EXPERIMENT.ERROR.INVALID_DEFAULT_LANG_CODE':
    '默认语言代码非标准，请参考语言标准文档',
  'PUSH.EXPERIMENT.ERROR.INVALID_OTHER_LANG_CODE':
    '其他语言代码非标准，请参考语言标准文档',
  'PUSH.EXPERIMENT.ERROR.DUPLICATE_LANG': '语言重复',
  'PUSH.EXPERIMENT.ERROR.EMPTY_LANG_CONTENT': '语言下推送内容为空',

  // 创建实验
  'PUSH.EXPERIMENT.CREATE.ADD.EXPERIMENT.UPLOADED': '文件校验通过',
  'PUSH.EXPERIMENT.CREATE.ADD.EXPERIMENT.UPLOAD_FAILED': '文件上传失败',
  'PUSH.EXPERIMENT.CREATE.JSON.TIPS': '仅支持JSON文件',
  'PUSH.EXPERIMENT.FILE.UPLOAD.ERROR.MSG': '文件上传失败',
  'PUSH.EXPERIMENT.SUBMIT.SUCCEEDED': '提交发布申请成功',
  'PUSH.EXPERIMENT.DAY.PLACEHOLDER': '第{num}天',
  'PUSH.EXPERIMENT.GROUP.PLACEHOLDER': '第{num}组',
  'PUSH.EXPERIMENT.GROUP.TOOLTIP': '组id: {name}',

  // 创建实验流程：步骤标签（步骤1-4）
  'PUSH.EXPERIMENT.CREATE.STEP.1': '基础信息',
  'PUSH.EXPERIMENT.CREATE.STEP.2': '语言配置',
  'PUSH.EXPERIMENT.CREATE.STEP.3': '推送规划',
  'PUSH.EXPERIMENT.CREATE.STEP.4': '推送内容',
  // 创建实验流程-步骤1 基础信息：页面大标题 / 副标题
  'PUSH.EXPERIMENT.CREATE.BASIC.TITLE': '实验基础信息',
  'PUSH.EXPERIMENT.CREATE.BASIC.DESC': '填写基础信息，方便后续管理和识别实验。',
  // 创建实验流程-步骤1 基础信息：字段
  'PUSH.EXPERIMENT.CREATE.NAME.LABEL': '实验名称',
  'PUSH.EXPERIMENT.CREATE.NAME.PLACEHOLDER': '请输入实验名称',
  'PUSH.EXPERIMENT.CREATE.NAME_EXISTS': '推送名称已存在，请更换名称后重试。',
  'PUSH.EXPERIMENT.CREATE.START.LABEL': '开始时间',
  'PUSH.EXPERIMENT.CREATE.END.LABEL': '结束时间',
  'PUSH.EXPERIMENT.CREATE.DATE.PLACEHOLDER': '选择日期',
  'PUSH.EXPERIMENT.CREATE.DATE.DESC': '所有实验组共用该实验周期',
  // 创建实验流程-步骤1 基础信息：底部按钮
  'PUSH.EXPERIMENT.CREATE.BUTTON.SAVE_DRAFT': '保存草稿',
  'PUSH.EXPERIMENT.CREATE.BUTTON.PREV': '上一步',
  'PUSH.EXPERIMENT.CREATE.BUTTON.NEXT': '下一步',
  'PUSH.EXPERIMENT.CREATE.BUTTON.SUBMIT_APPROVAL': '提交审批',
  'PUSH.EXPERIMENT.CREATE.BUTTON.SUBMIT_APPROVAL_SUCCESS': '提交成功',
  // 各步骤「下一步 / 提交审批」按钮置灰时的 hover 提示（四步共用）
  'PUSH.EXPERIMENT.CREATE.BUTTON.NEXT_DISABLED_TIP':
    '请先完成配置，再进行下一步',
  // 创建实验流程-提交审批 / 保存草稿：结果与前置校验提示
  'PUSH.EXPERIMENT.CREATE.SAVE_DRAFT_SUCCESS': '草稿已保存',
  'PUSH.EXPERIMENT.CREATE.LEAVE_CONFIRM_TITLE': '是否确认退出实验创建？',
  'PUSH.EXPERIMENT.CREATE.LEAVE_NOT_SAVE': '不保存草稿',
  'PUSH.EXPERIMENT.CREATE.LEAVE_CONFIRM_DESC':
    '选择不保存，您修改的内容将被删除且不可恢复。',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_SUCCESS': '已提交审批，等待审核',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_FAILED': '提交失败，请稍后重试',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_BASIC':
    '请先完善「实验基础信息」：实验名称与推送周期为必填项，且名称不可重复',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_LANG': '请先在「语言配置」中选择默认语言',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_CONTENT':
    '以下分组还未生成推送内容，请补全后再提交：{groups}',
  'PUSH.EXPERIMENT.CREATE.CHECK_PASSED':
    '校验通过，请点击右上角「提交发布申请」完成提交',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_CONFIRM_TITLE': '确认提交审批',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_CONFIRM_DESC':
    '即将对当前配置做提交前校验。校验通过后，还需点击右上角「提交发布申请」完成发布，是否继续？',
  'PUSH.EXPERIMENT.CREATE.CHECK_JSON_FAILED': '配置校验未通过，请检查后重试',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_CHECK':
    '请先在步骤4点击「提交审批」完成配置校验后，再提交发布申请',
  // 提交审批 / 校验错误码文案（error_type 1001~1019，随界面语言切换）
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1001':
    '推送配置名称已存在，请更换名称后重试。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1002':
    '当前已有正在运行的推送实验配置，请先结束或暂停现有实验。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1003':
    '计划开始时间过早或格式不正确，请设置为当前时间之后的时间。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1004':
    '推送配置格式错误，请检查 JSON 内容后重试。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1005':
    '推送实验缺少分组或分组内容为空，请至少添加一个分组和推送内容。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1006':
    '部分配置字段填写不正确，请检查时间、推送 ID 等信息。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1007': '推送标题或正文过长，请缩短后重试。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1008':
    '结束时间格式不正确，或早于开始时间，请重新设置。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1009':
    '推送内容（数据载荷）过大，请减少内容后重试。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1010':
    '该配置已通过审批，无法再次编辑。如需修改请创建新版本。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1011':
    '该配置已被驳回，请根据审批意见修改后重新提交。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1012':
    '该配置已过期，请重新设置有效时间或创建新配置。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1013':
    '消息有效期（TTL）格式不正确，请重新填写。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1014':
    '未设置默认语言，请选择一种语言作为默认语言。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1015':
    '部分语言代码无效，请检查并重新选择。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1016':
    '某些语言的内容为空，请填写完整后再提交。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1017': '存在重复的语言配置，请删除重复项。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1018':
    '所选语言未在系统中配置，请先添加该语言。',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1019':
    '推送时间设置，不符合防打扰策略设置。',
  // 创建实验流程-步骤2 语言配置：页面副标题
  'PUSH.EXPERIMENT.CREATE.LANG.TITLE': '语言配置',
  'PUSH.EXPERIMENT.CREATE.LANG.DESC':
    '选择实验默认语言，系统会根据项目受众自动推荐覆盖语言。',
  // 创建实验流程-步骤2 语言配置：字段 / 统计 / 提示
  'PUSH.EXPERIMENT.CREATE.LANG.LABEL': '默认语言',
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT': '覆盖语言：{num} 种',
  // 覆盖语言数量（仅数字加粗）：前缀 + num + 后缀
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT_PREFIX': '覆盖语言：',
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT_SUFFIX': ' 种',
  // 已选语言数：覆盖语言（可取消） + 手动勾选的未覆盖语言，随选择实时变化
  'PUSH.EXPERIMENT.CREATE.LANG.SELECTED_COUNT': '已选语言：{num}',
  'PUSH.EXPERIMENT.CREATE.LANG.PULLED_TIP': '已根据项目受众自动拉取语言',
  'PUSH.EXPERIMENT.CREATE.LANG.UNKNOWN_TIP': '未知语言用户占比 ',
  'PUSH.EXPERIMENT.CREATE.LANG.DEFAULT_TAG': '默认',
  'PUSH.EXPERIMENT.CREATE.LANG.ADDED_TAG': '已添加',
  'PUSH.EXPERIMENT.CREATE.LANG.VIEW_UNCOVERED': '查看未覆盖语言（{num} 种）',
  // 创建实验流程-步骤3 分组与推送规划：页面大标题 / 副标题 / 状态
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.TITLE': '分组与推送规划',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DESC_PRE': '分组信息已从 ',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DESC_POST':
    ' 平台自动拉取，请完成各组实验周期和推送时间规划。',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.SYNCED': '分组信息已同步',
  // 创建实验流程-步骤3 分组与推送规划：实验周期
  // 周期选择上方标题行：xx组 · 时间规划
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.GROUP_TIME_TITLE': '{group} · 时间规划',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD': '实验周期',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD_DAYS': '{num} 天',
  // 自定义周期输入框的单位（数字后的「天」）
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD_DAYS_UNIT': '天',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.CUSTOM': '自定义',
  // 创建实验流程-步骤3 分组与推送规划：推送时间点
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PUSH_TIME': '推送时间点',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.MODE_SAME': '每日相同',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.MODE_DAILY': '按天配置',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAILY_LABEL': '每日推送时间',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAY_N': '第 {num} 天',
  // 按天配置每张卡片头部的当日推送次数（跟随已添加时间点数量变化；带分隔杠，与步骤4 预览行 "- X 条推送" 风格一致）
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAY_PUSH_COUNT': '· {count} 次推送',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ADD_TIME': '添加时间点',
  // 时间点被删空时的引导提示
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.EMPTY_TIME_TIP': '请添加时间点，推荐3-4个',
  // 创建实验流程-步骤3 分组与推送规划：应用到其他组
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_BTN': '应用到其他分组',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_TITLE': '将当前分组的推送规划应用到',
  // 应用到其他组：弹窗内描述（目标为「以下分组」）
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_DESC':
    '将当前分组的实验周期和推送时间同步到以下分组',
  // 应用到其他组：按钮旁说明（目标为「其他分组」）
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_OTHER_DESC':
    '将当前分组的设置（实验周期和推送时间）同步到其他分组',
  // 应用到其他组：应用成功提示
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_SUCCESS': '应用成功',
  // 创建实验流程-步骤3 分组与推送规划：说明
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ZONE_TITLE': '推送时区说明',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ZONE_BODY':
    '所有推送均按玩家设备本地时间自动触发，无需手动设置时区。例如，一条计划在 09:00 发送的推送，将在欧洲、北美及其他地区用户的本地时间 09:00 送达。',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_TITLE': '防打扰策略',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_BODY':
    '推送时间与频次须满足防打扰策略中的最小间隔与频次上限要求。',
  // 创建实验流程-步骤3 时间规划：防打扰策略校验弹窗
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_TITLE': '防打扰策略检查提示',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_LINE':
    '「{group}」分组的推送时间设置超出了消息推送数量限制。',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_FOOTER': '请调整后继续配置',
  // 创建实验流程-步骤4 推送内容：页面大标题 / 副标题 / 配置方式
  'PUSH.EXPERIMENT.CREATE.CONTENT.TITLE': '推送内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.DESC':
    '配置推送文案，AI 将为当前分组生成标题与正文，也支持导入已有内容。',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CARD_TITLE': '推送内容配置',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GROUP_CARD_TITLE': '{group} · 推送内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_AI': 'AI 自动生成',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_CSV': '导入 CSV',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_AI_TIP_DESC':
    'AI 会根据您的语言风格和推送目标描述，自动生成标题和正文，并支持自动翻译成多种语言。',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_CSV_TIP_DESC':
    '上传预先准备好的 CSV 文件，包含每种语言版本的标题和正文。适合已有推送内容的场景。',
  // 创建实验流程-步骤4 推送内容：推送目标描述
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_LABEL': '推送目标描述',
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_PLACEHOLDER':
    '请描述本次推送目标，例如：召回沉默玩家、宣传新赛季活动。',
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_MIN_LENGTH':
    '推送目标描述不少于 5 个字符',
  // 创建实验流程-步骤4 推送内容：语言风格
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_LABEL': '语言风格',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_INCENTIVE': '激励型',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_GENTLE': '温和型',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_RELAX': '轻松型',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_INTIMATE': '亲密型',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_CUSTOM': '自定义',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_EMPTY': '未选择',
  // 创建实验流程-步骤4 推送内容：表情符号
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_LABEL': '表情符号',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_MUST_HAVE': '必须包含',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_MUST_NOT_HAVE': '不包含',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_CASUALLY': '随机生成',
  // 创建实验流程-步骤4 推送内容：生成按钮 / 过程状态
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATE_BTN': '为当前分组生成内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATING': '正在生成标题与正文…',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_1': '正在筛选推送素材',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_2': '正在规划推送方案',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_3': '正在生成默认语言内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_4': '正在生成多语言内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_5': '正在校验内容质量',
  'PUSH.EXPERIMENT.CREATE.CONTENT.RESULT_TIP_MAIN': '推送内容已经生成',
  'PUSH.EXPERIMENT.CREATE.CONTENT.RESULT_TIP_GROUP': ' · {group}（{num} 条）',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATED_NOTIFY':
    '已为分组「{group}」生成 {num} 条推送内容',
  'PUSH.EXPERIMENT.CREATE.CONTENT.REGENERATE': '重新生成',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CUSTOM_PLACEHOLDER':
    '输入自定义语言风格（如：正式、俏皮）',
  // 创建实验流程-步骤4 推送内容：CSV 导入 结果条（默认隐藏，前端解析完成后才展示）
  // 成功态复用 RESULT_TIP_MAIN / RESULT_TIP_GROUP 分段渲染；此条为文件级失败提示
  // {group}=当前分组名（由前端解析后动态填充）
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_PARSE_FAIL': '文件解析失败 · {group}',
  // 创建实验流程-步骤4 推送内容：CSV 导入 行级错误提示
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_HEADER':
    '文件表头不符合模板要求，请包含 day、time、lang、title、body 列后重新上传',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_LENGTH':
    '第 {row} 行的标题或正文超出长度限制（标题 ≤ 65 字符、正文 ≤ 240 字符），请精简后重新上传',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_EMPTY':
    '第 {row} 行的语言内容为空，请补全该行的标题与正文',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_LANG':
    '第 {row} 行的语言未覆盖，请参照语言配置列表修改 lang 列',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_TIME_PLAN_MISMATCH':
    '导入文件的时间与已配置的时间规划不一致，请先调整时间规划或修改 CSV 后再导入',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERROR_ROW_PREFIX': '第 {row} 行：',
  // 创建实验流程-步骤4 推送内容：CSV 上传区
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_UPLOAD_TITLE': '上传 CSV 文件',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_FORMAT':
    '仅支持 CSV 或 Excel 格式，当前文件为 {ext} 格式，请转换后重新上传',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_SIZE':
    '文件大小超出限制（最大 {max}），请精简内容后重新上传',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_DRAG_TIP': '选择文件或拖拽至此处',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_FORMAT_HINT':
    '支持 CSV / Excel 格式，列包含：day、time、lang、title、body',
  // 创建实验流程-步骤4 推送内容：内容预览（AI 自动生成与 CSV 导入共用）
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_TITLE': '推送内容预览',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_EDIT_TIP': '标题和正文均可编辑',
  // 预览 Day 分组行：前半段「第 N 天」加粗，后半段条数常规字重
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_DAY': '第 {day} 天',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_DAY_COUNT': '- {count} 条推送',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_TIME': '时间',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_TITLE': '标题',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_BODY': '正文',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_PUSH_ID': '推送 ID',

  'PUSH.EXPERIMENT.CREATE.GROUP_DONE': '已设置',
  'PUSH.EXPERIMENT.CREATE.GROUP_NO_DONE': '未设置',
  // 新增实验弹窗：手动创建（向导模式）卡片
  'PUSH.EXPERIMENT.CREATE.MANUAL.TITLE': '手动创建',
  'PUSH.EXPERIMENT.CREATE.MANUAL.DESC': '逐步配置，AI 自动生成推送内容',
  // 新增实验弹窗：导入 JSON 卡片
  'PUSH.EXPERIMENT.CREATE.JSON.TITLE': '导入Json文件创建',
  'PUSH.EXPERIMENT.CREATE.JSON.DESC':
    '已存在完整的Json格式的配置信息，导入后可快速完成实验创建。',
  // 步骤3 时间规划：开始/结束时间跨度小于实验周期（周期天数超过推送窗口）的拦截提示
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.CYCLE_EXCEED_WINDOW':
    '开始和结束时间的跨度小于实验周期，请延长实验时间或调整周期设置。',
};
